<div
  (click)="handleOpenFolder && !onlyFolder ? handleOpenFolder() : null"
  [class.only-folder]="onlyFolder"
  class="pitchcard-folder-wrapper">
  <svg
    aria-hidden="true"
    class="pocket-background"
    viewBox="0 0 80 80"
    preserveAspectRatio="none">
    <rect
      width="80"
      height="80"
      rx="7"
      [attr.fill]="'url(#' + backgroundGradientId + ')'" />
    <defs>
      <linearGradient
        [attr.id]="backgroundGradientId"
        x1="39.9194"
        y1="0"
        x2="39.9194"
        y2="94.6573"
        gradientUnits="userSpaceOnUse">
        <stop [attr.stop-color]="jacketColor" />
        <stop offset="1" [attr.stop-color]="jacketShadowColor" />
      </linearGradient>
    </defs>
  </svg>
  <app-pitch-card
    #businessCard
    *ngIf="previewBusiness"
    [inputBusinessDetails]="previewBusiness"
    [disabled]="true"
    [autoplayOnLoad]="false"
    [scale]="scaleFactor"
    [videoPlaybackEnabled]="false"
    class="pocket-card">
  </app-pitch-card>
  <div
    (click)="handleAddContent()"
    *ngIf="onlyFolder"
    class="only-folder-wrapper">
    <div [hidden]="folderLoader !== pitchCardFolder.id" class="folder-loader">
      <i class="fa fa-spinner fa-pulse fa-5x fa-fw"></i>
    </div>
    <div *ngIf="!folderLoader" class="move-container">
      <span>Move Here</span>
      <span class="icon"></span>
    </div>
  </div>
  <div
    (click)="
      pitchCardFolder.children && onlyFolder && pitchCardFolder?.children.length
        ? handleOpenFolder()
        : handleAddContent()
    "
    class="folder-wrapper">
    <svg
      aria-hidden="true"
      class="pocket-jacket-background"
      viewBox="0 0 80 52"
      preserveAspectRatio="none">
      <path
        [attr.fill]="jacketColor"
        d="M65.78 3.44621C69.3282 -0.203691 76.7922 -0.247127 80 0.187387V43.7C80 48.283 76.283 52 71.7 52H8.3C3.717 52 0 48.283 0 43.7V0.187387C3.20782 -0.247127 10.5105 -0.203691 14.0587 3.44621C18.4938 8.00864 19.4981 9.23082 23.5149 9.23082H56.3238C60.3406 9.23082 61.3449 8.00864 65.78 3.44621Z" />
    </svg>
    <div class="pocket-label">
      <img
        *ngIf="isOrganizationFolder"
        alt="team icon"
        class="org-icon"
        src="assets/images/pocket-jacket/team-icon.svg" />
      <img
        *ngIf="isDefaultPocket && pitchCardFolder.name === 'Inbox'"
        alt="Inbox"
        class="jacket-icon"
        src="assets/images/pocket-jacket/inbox-logo.svg" />
      <img
        *ngIf="isDefaultPocket && pitchCardFolder.name === 'Home'"
        alt="Home pocket"
        class="jacket-icon"
        src="assets/images/pocket-jacket/home-pocket-icon.svg" />
      <img
        *ngIf="isDefaultPocket && pitchCardFolder.name === 'Customer Support'"
        alt="Customer Support"
        class="jacket-icon"
        src="assets/images/pocket-jacket/customer-support-logo.svg" />
      <img
        *ngIf="isDefaultPocket && pitchCardFolder.name === 'Speed Networking'"
        alt="Speed Networking"
        class="jacket-icon"
        src="assets/images/pocket-jacket/swap-logo.svg" />
      <img
        *ngIf="isDefaultPocket && pitchCardFolder.name === 'Favorites'"
        alt="Favorites"
        class="jacket-icon"
        src="assets/images/pocket-jacket/icon-like-black.svg" />
      <span class="folder-name">
        {{
          pitchCardFolder.name
            ? (pitchCardFolder.name | titlecase)
            : 'Team Manager'
        }}
      </span>
    </div>
  </div>
</div>
